module.exports = __webpack_public_path__ + "img/emoticon-nps-8-on.dd3ab4dd.svg";